module.exports = __webpack_public_path__ + "img/rose-alt.760f494e.png";